import script from "./CostAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./CostAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./CostAnalysis.vue?vue&type=style&index=0&id=34eb535a&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34eb535a"]])

export default __exports__